import model from 'modules/group/groupModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.ebox,
  fields.createdAt,
  fields.updatedAt
];
